export default __webpack_public_path__ + "static/media/hollywood_grey.cb4c44ed.webp";